import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOP_Features = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Features of OOP"
      videos={[
        "https://www.youtube.com/embed/pTB0EiLXUC8", // Object-Oriented Programming, Simplified
      ]}
      takeaways={[
        { text: "Sometimes, questions can be asked to explain the features or benefits of OOP." },
        { text: "Be prepared to write all the key points mentioned in the video." },
        { text: "Understand the differences between procedural programming and object-oriented programming." },
      ]}
      questions={[]} // No specific questions provided
      exampleVideos={[]} // No example question videos provided
    />
);
}

export default OOP_Features;
